import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import { selectAuthenticationContext } from '@innovyze/stylovyze/lib/selectors';
import { setIsLoading as setLoadingAction } from '@innovyze/stylovyze/lib/actions/app.actions';
import { useFeatureFlags } from '@innovyze/stylovyze/lib/contexts/FeatureFlag';
import { useSettings } from '@innovyze/stylovyze/lib/contexts/Settings';
import { useSiteConfig } from '@innovyze/stylovyze/lib/contexts';
export const LoadingContext = React.createContext({
    isLoading: true,
});
export const useLoadingContext = () => useContext(LoadingContext);
export const LoadingProvider = ({ children }) => {
    const { configLoaded } = useSiteConfig();
    const { isInitializing } = useSelector(selectAuthenticationContext);
    const { featuresLoaded } = useFeatureFlags();
    const { settingsLoaded } = useSettings();
    const dispatch = useDispatch();
    const isApplicationLoading = !configLoaded || isInitializing || !featuresLoaded || !settingsLoaded;
    const [isLoading, setIsLoading] = useState(isApplicationLoading);
    useEffect(() => {
        if (isApplicationLoading !== isLoading) {
            setIsLoading(isApplicationLoading);
            dispatch(setLoadingAction(isApplicationLoading));
        }
    }, [isApplicationLoading, isInitializing, settingsLoaded, featuresLoaded]);
    return (React.createElement(LoadingContext.Provider, { value: {
            isLoading,
        } }, children));
};
export default LoadingProvider;
